import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {ProfileService} from '../../../profile/profile.service';
import {Observable} from 'rxjs/Observable';

@Directive({
  selector: '[appHasPermission]'
})
export class HasPermissionDirective {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private profileService: ProfileService) {

  }

  @Input() set appHasPermission(permissionName: string) {

    (<Observable<boolean>>this.profileService.hasPermission(permissionName)).subscribe(
      (hasPermission: boolean) => {
        if (hasPermission) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/has-permission/has-permission.directive.ts